"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaypalTaxTotal = void 0;
const checkout_frontend_library_1 = require("@bold-commerce/checkout-frontend-library");
const src_1 = require("..");
function getPaypalTaxTotal() {
    const taxes = (0, checkout_frontend_library_1.getTaxes)();
    const { iso_code: currencyCode } = (0, checkout_frontend_library_1.getCurrency)();
    const taxValue = taxes.reduce(((sum, item) => sum + item.value), 0);
    return {
        currency_code: currencyCode,
        value: (0, src_1.getValueByCurrency)(taxValue, currencyCode)
    };
}
exports.getPaypalTaxTotal = getPaypalTaxTotal;
